<nb-layout>
  <nb-layout-column>
    <nb-card [nbSpinner]="submitted" nbSpinnerStatus="info" nbSpinnerSize="xlarge"
      [nbSpinnerMessage]="'ALGEMEEN.EVEN_GEDULD' | translate">
      <nb-card-body>
        <div class="col-xl-4 col-lg-6 col-md-8 col-sm-12">
          <h3 class="title">{{ 'WACHTWOORD_VERGETEN.TITEL' | translate }}</h3>
          <p class="form-text sub-title">{{ 'WACHTWOORD_VERGETEN.TEKST_HINT' | translate }}</p>
          <form (ngSubmit)="reset()" #form="ngForm" autocomplete="nope">
            <div *ngIf="errors && errors.length > 0 && !submitted" class="alert alert-danger" role="alert">
              <div><strong>Oops!</strong></div>
              <div *ngFor="let error of errors">{{ error }}</div>
            </div>
            <div class="form-group">{{ 'WACHTWOORD_VERGETEN.GEBRUIKERSNAAM' | translate }}<label for="input-username"
                class="sr-only">{{ 'WACHTWOORD_VERGETEN.GEBRUIKERSNAAM' | translate }}</label> <input name="username"
                [(ngModel)]="user.username" id="input-username" class="form-control"
                [placeholder]="'WACHTWOORD_VERGETEN.GEBRUIKERSNAAM' | translate | lowercase" #username="ngModel"
                [class.form-control-danger]="username.invalid && username.touched" autofocus [required]="true">
              <small class="form-text error"
                *ngIf="username.invalid && username.touched && username.errors?.required">{{
                'WACHTWOORD_VERGETEN.MELDING.GEBRUIKERSNAAM_VERPLICHT' | translate }}</small>
            </div>
            <div class="form-group">{{ 'WACHTWOORD_VERGETEN.EMAILADRES' | translate }} <label for="input-emai"
                class="sr-only">{{ 'WACHTWOORD_VERGETEN.EMAILADRES' | translate }}</label> <input name="email"
                [(ngModel)]="user.email" id="input-username" class="form-control"
                [placeholder]="'WACHTWOORD_VERGETEN.EMAILADRES' | translate | lowercase" #email="ngModel"
                [class.form-control-danger]="username.invalid && username.touched" autofocus [required]="true">
              <small class="form-text error" *ngIf="email.invalid && email.touched && email.errors?.required">{{
                'WACHTWOORD_VERGETEN.MELDING.EMAILADRES_VERPLICHT' | translate }}</small>
            </div>
            <!-- <div class="form-group"> <label for="input-password" class="sr-only">Wachtwoord</label> <input name="password" [(ngModel)]=
                  "user.password" type="password" id="input-password" class="form-control" placeholder="wachtwoord" #password="ngModel" [class.form-control-danger]="password.invalid && password.touched"
                  [required]="true">
                  <small class="form-text error" *ngIf="password.invalid && password.touched && password.errors?.required">Wachtwoord is verplicht</small>                
              </div>   -->
            <div class="pull-right"><a [routerLink]="['/auth/login']"><span>{{ 'WACHTWOORD_VERGETEN.TERUG' | translate
                  }}</span></a></div>
            <br />
            <button [disabled]="submitted || !form.valid" class="btn btn-block btn-success"
              [class.btn-pulse]="submitted">{{ 'WACHTWOORD_VERGETEN.BUTTON.CODE_AANVRAGEN' | translate }}</button>
          </form>
        </div>
      </nb-card-body>
    </nb-card>
  </nb-layout-column>
</nb-layout>